export const generatedUiFidelityLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-22T00:00:00.000Z",
  "mode": "deterministic-ui-fidelity-ledger",
  "operatingRule": "This ledger binds the six accepted reference mockups to rendered browser screenshots. It is visual QA evidence, not owner approval. Public/customer release remains blocked until side-by-side review is approved.",
  "referenceDir": "evidence/ui-reference-mockups",
  "captureDir": "evidence/ui-fidelity-captures/latest",
  "requiredPageCount": 6,
  "referenceImageCount": 6,
  "renderedCaptureCount": 6,
  "automatedEvidenceCompleteCount": 6,
  "blockedPageCount": 6,
  "pageApprovalAllowedCount": 0,
  "ownerApprovalAllowed": false,
  "releaseApprovalAllowed": false,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "requiredBrowserCommand": "BROWSER_REGRESSION_SCREENSHOT_DIR=evidence/ui-fidelity-captures/latest npm run test:browser",
  "requiredApprovalAction": "Owner must compare the six reference PNGs with the six rendered desktop screenshots and record approval or mismatch work orders.",
  "pageRecords": [
    {
      "id": "command-overview",
      "label": "Command Overview",
      "navLabel": "Command Overview",
      "referencePath": "evidence/ui-reference-mockups/command-overview.png",
      "renderedPath": "evidence/ui-fidelity-captures/latest/command-overview-desktop.png",
      "referenceImage": {
        "path": "evidence/ui-reference-mockups/command-overview.png",
        "exists": true,
        "bytes": 1385890,
        "sha256": "sha256-6cde350718f2d48df3c030e5d4c7e4c73042e9ccff8fbf65c8a5c5b60d625e9b",
        "dimensions": {
          "width": 1487,
          "height": 1058
        }
      },
      "renderedImage": {
        "path": "evidence/ui-fidelity-captures/latest/command-overview-desktop.png",
        "exists": true,
        "bytes": 310925,
        "sha256": "sha256-8b8edee9eca6e8e21bab2c19553a4de726d5f8a48f5ccd36c4523bc4f6a1785f",
        "dimensions": {
          "width": 1500,
          "height": 1000
        }
      },
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "automatedEvidenceComplete": true,
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "blockers": [
        "Owner side-by-side visual approval is not recorded.",
        "Pixel/semantic tolerance has not been accepted by product owner."
      ],
      "nextAction": "Review the reference and rendered screenshots side by side, record owner approval or page-specific mismatch work orders, then regenerate this ledger.",
      "pageHash": "sha256-98b89f61e030e3ef30fa94b61c8fca5dcdf11a9a5128e8752d0743de687404a2"
    },
    {
      "id": "scenario-compare",
      "label": "Scenario Compare",
      "navLabel": "Scenario Compare",
      "referencePath": "evidence/ui-reference-mockups/scenario-compare.png",
      "renderedPath": "evidence/ui-fidelity-captures/latest/scenario-compare-desktop.png",
      "referenceImage": {
        "path": "evidence/ui-reference-mockups/scenario-compare.png",
        "exists": true,
        "bytes": 1396929,
        "sha256": "sha256-286c613f80e9c30deede278485b12a11a2a9b9bfe7380f3c0cf5f371cac1a360",
        "dimensions": {
          "width": 1487,
          "height": 1058
        }
      },
      "renderedImage": {
        "path": "evidence/ui-fidelity-captures/latest/scenario-compare-desktop.png",
        "exists": true,
        "bytes": 265638,
        "sha256": "sha256-0ae22da4c49c0316efab0cebe96eb61ad2248c2faa88f4180dbd55f05f9f6b82",
        "dimensions": {
          "width": 1500,
          "height": 1000
        }
      },
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "automatedEvidenceComplete": true,
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "blockers": [
        "Owner side-by-side visual approval is not recorded.",
        "Pixel/semantic tolerance has not been accepted by product owner."
      ],
      "nextAction": "Review the reference and rendered screenshots side by side, record owner approval or page-specific mismatch work orders, then regenerate this ledger.",
      "pageHash": "sha256-6c35b01d7df68ed6906b3dadfe61778cea64c82899ec34e95152529d05e62574"
    },
    {
      "id": "solar-clock",
      "label": "Solar Clock",
      "navLabel": "Solar Clock",
      "referencePath": "evidence/ui-reference-mockups/solar-clock.png",
      "renderedPath": "evidence/ui-fidelity-captures/latest/solar-clock-desktop.png",
      "referenceImage": {
        "path": "evidence/ui-reference-mockups/solar-clock.png",
        "exists": true,
        "bytes": 1456253,
        "sha256": "sha256-a597e9c2fa7c8c779e6af4336bb209bcbb5314cb1edeabb3accde75069ee103b",
        "dimensions": {
          "width": 1487,
          "height": 1058
        }
      },
      "renderedImage": {
        "path": "evidence/ui-fidelity-captures/latest/solar-clock-desktop.png",
        "exists": true,
        "bytes": 452740,
        "sha256": "sha256-69086aaabc1e056422d3b02ebd239fb03fb4473aa8507c3b298b8d5ca8f49ea2",
        "dimensions": {
          "width": 1500,
          "height": 1000
        }
      },
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "automatedEvidenceComplete": true,
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "blockers": [
        "Owner side-by-side visual approval is not recorded.",
        "Pixel/semantic tolerance has not been accepted by product owner."
      ],
      "nextAction": "Review the reference and rendered screenshots side by side, record owner approval or page-specific mismatch work orders, then regenerate this ledger.",
      "pageHash": "sha256-4dd0967fe9ca6aa82f1448c08e1b65f27c87ae1f72ce7f968e1ff5b278c786c2"
    },
    {
      "id": "body-ledger",
      "label": "Body Ledger",
      "navLabel": "Body Ledger",
      "referencePath": "evidence/ui-reference-mockups/body-ledger.png",
      "renderedPath": "evidence/ui-fidelity-captures/latest/body-ledger-desktop.png",
      "referenceImage": {
        "path": "evidence/ui-reference-mockups/body-ledger.png",
        "exists": true,
        "bytes": 1657870,
        "sha256": "sha256-b71ff86599eff2632c67aba558101e182dc03a78c34e3311270db7d73e2ea21b",
        "dimensions": {
          "width": 1487,
          "height": 1058
        }
      },
      "renderedImage": {
        "path": "evidence/ui-fidelity-captures/latest/body-ledger-desktop.png",
        "exists": true,
        "bytes": 333718,
        "sha256": "sha256-cc3e583696ac13af140b201a63ff68b4cf756c6e917df91ab11d6cd192e08149",
        "dimensions": {
          "width": 1500,
          "height": 1000
        }
      },
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "automatedEvidenceComplete": true,
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "blockers": [
        "Owner side-by-side visual approval is not recorded.",
        "Pixel/semantic tolerance has not been accepted by product owner."
      ],
      "nextAction": "Review the reference and rendered screenshots side by side, record owner approval or page-specific mismatch work orders, then regenerate this ledger.",
      "pageHash": "sha256-83d4be8762f659a85efa76e7565825aee038ff5af8f323140c9a97dadbc7d356"
    },
    {
      "id": "process-lab",
      "label": "Process Lab",
      "navLabel": "Process Lab",
      "referencePath": "evidence/ui-reference-mockups/process-lab.png",
      "renderedPath": "evidence/ui-fidelity-captures/latest/process-lab-desktop.png",
      "referenceImage": {
        "path": "evidence/ui-reference-mockups/process-lab.png",
        "exists": true,
        "bytes": 1560228,
        "sha256": "sha256-9b0f5c1356275d8cb61342d71cdec98146e1ad83fa6df5d4fad88ebddb332119",
        "dimensions": {
          "width": 1487,
          "height": 1058
        }
      },
      "renderedImage": {
        "path": "evidence/ui-fidelity-captures/latest/process-lab-desktop.png",
        "exists": true,
        "bytes": 327991,
        "sha256": "sha256-88167e14fd917a03ba9518185525dfff632a024d053adb91885c574224967447",
        "dimensions": {
          "width": 1500,
          "height": 1000
        }
      },
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "automatedEvidenceComplete": true,
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "blockers": [
        "Owner side-by-side visual approval is not recorded.",
        "Pixel/semantic tolerance has not been accepted by product owner."
      ],
      "nextAction": "Review the reference and rendered screenshots side by side, record owner approval or page-specific mismatch work orders, then regenerate this ledger.",
      "pageHash": "sha256-418d262e8828d43508e7eb9ddc8f4c0ac03d960eeb50277c799a9f8e258d90b3"
    },
    {
      "id": "claims-register",
      "label": "Claims Register",
      "navLabel": "Claims Register",
      "referencePath": "evidence/ui-reference-mockups/claims-register.png",
      "renderedPath": "evidence/ui-fidelity-captures/latest/claims-register-desktop.png",
      "referenceImage": {
        "path": "evidence/ui-reference-mockups/claims-register.png",
        "exists": true,
        "bytes": 1436536,
        "sha256": "sha256-5c1adf7727684bee9081bed9603a648c77b52ccc164b03f3f96b8399042cb3d4",
        "dimensions": {
          "width": 1487,
          "height": 1058
        }
      },
      "renderedImage": {
        "path": "evidence/ui-fidelity-captures/latest/claims-register-desktop.png",
        "exists": true,
        "bytes": 333705,
        "sha256": "sha256-1c534bbf4206d038c6f045a3af110fbd06e8b0bd09c95021045f45ef66a9dac2",
        "dimensions": {
          "width": 1500,
          "height": 1000
        }
      },
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "automatedEvidenceComplete": true,
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "blockers": [
        "Owner side-by-side visual approval is not recorded.",
        "Pixel/semantic tolerance has not been accepted by product owner."
      ],
      "nextAction": "Review the reference and rendered screenshots side by side, record owner approval or page-specific mismatch work orders, then regenerate this ledger.",
      "pageHash": "sha256-6852676021239079f912197ace158e4147b0c1ff305440fbe074d3ace3774cbe"
    }
  ],
  "markdownPath": "public/ui-fidelity-ledger.md",
  "markdownHash": "sha256-4e7d064df65dc449245a25582d7eac57be97b4f2c0e55605f14db1f26134eecc",
  "ledgerHash": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58"
}
;
